module.exports = __webpack_public_path__ + "img/Cross.edb8df54.svg";